import type { KeyboardEvent } from 'react'

// Only key dispatch is shared. Callers retain draft, blur, pending, validation,
// and save-completion semantics, which differ between placed POs and invoices.
export function inlineEditKey(event: KeyboardEvent, commit: () => void, cancel: () => void) {
  if (event.key === 'Enter') commit()
  else if (event.key === 'Escape') cancel()
}

export function inlineTextareaKey(event: KeyboardEvent, commit: () => void, cancel: () => void) {
  if ((event.metaKey || event.ctrlKey) && event.key === 'Enter') commit()
  else if (event.key === 'Escape') cancel()
}
